import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../components/Dashboard.vue'
import Menu from '../components/Menu.vue'
import History from '../components/History.vue'
import Allergy from '../components/Allergy.vue'
import Config from '../components/Config.vue'
import PrivacyPolicy from '../components/PrivacyPolicy.vue'
import About from '../components/About.vue'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/menu/:id',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/history',
      name: 'History',
      component: History
    },
    {
      path: '/allergy',
      name: 'Allergy',
      component: Allergy
    },
    {
      path: '/config',
      name: 'Config',
      component: Config
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    }
  ]
})
